import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { deviceResponseSchema } from '../types';

export const receiveDevice = createReceive('device', zodContract(deviceResponseSchema));
